import React from "react";
import { Divider } from "@patternfly/react-core";

import SchoolFooterBrand from "./brand/SchoolFooterBrand";
import SchoolFooterContent from "./SchoolFooterContent";
import SchoolFooterCopyright from "./copyright/SchoolFooterCopyright";

import "./SchoolFooter.css";

const SchoolFooter = () => {
  return (
    <footer className="school-footer">
      <div>
        <SchoolFooterBrand />

        <Divider />

        <SchoolFooterContent />

        <Divider />

        <SchoolFooterCopyright />
      </div>
    </footer>
  );
};

export default SchoolFooter;